var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: { title: "会员价格", visible: _vm.visibleSync, width: "600px" },
      on: {
        "update:visible": function($event) {
          _vm.visibleSync = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c("div", { staticClass: "f15 gray3 nowrap mar10-b flex" }, [
            _c("div", { staticClass: "fb" }, [_vm._v("商品：")]),
            _vm.vipInfo.goods
              ? _c(
                  "div",
                  { staticClass: "pad20-r" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: _vm.vipInfo.goods.skuName,
                          placement: "top"
                        }
                      },
                      [_c("div", [_vm._v(_vm._s(_vm.vipInfo.goods.skuName))])]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "fb" }, [_vm._v("价格：")]),
            _c("div", [
              _vm._v(
                _vm._s(_vm.vipInfo.goods && _vm.vipInfo.goods.currPrice) + "元"
              )
            ])
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                "header-row-class-name": "gray3",
                align: "center",
                data: _vm.tableData,
                stripe: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "memberLevelCn",
                  label: "会员类型",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsVipPrice",
                  label: "价格(元)",
                  align: "center"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "pad15-tb" }, [
            _c("i", { staticClass: "el-icon-info" }),
            _vm._v("\n      VIP商品点击（"),
            _c(
              "a",
              {
                staticClass: "blue",
                attrs: { href: _vm.scLink + "toVipIntroduce", target: "_blank" }
              },
              [_vm._v("链接")]
            ),
            _vm._v(
              "）可直接购买，养殖会员、运营中心会员、农信小站会员请联系平台客服\n      咨询，平台客服400-810-5353\n    "
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }